/**
 * System role types
 */
export enum SystemRole {
  USER = 'USER',
  ADMIN = 'ADMIN'
}

/**
 * Formats a SystemRole enum value into a human-readable string
 * @param role - The SystemRole enum value to format
 * @returns A formatted string representation of the business role
 *
 * @example
 * formatSystemRole(SystemRole.ADMIN) // returns "Administrator"
 * formatSystemRole(SystemRole.USER) // returns "User"
 */
export function formatSystemRole(role: SystemRole): string {
  switch (role) {
    case SystemRole.ADMIN:
      return 'Administrator';
    case SystemRole.USER:
      return 'User';
    default:
      // Handle case where role might be undefined or not in enum
      return role ? String(role).replace(/_/g, ' ').toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase()) : 'Unknown';
  }
}